import { render, staticRenderFns } from "./ProjectsColumn.vue?vue&type=template&id=d5884522&scoped=true&"
import script from "./ProjectsColumn.vue?vue&type=script&lang=js&"
export * from "./ProjectsColumn.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsColumn.vue?vue&type=style&index=0&id=d5884522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5884522",
  null
  
)

export default component.exports